const METERS_TO_FEET = 3.28084;

/**
 * Converts a length in meters to feet.
 * Geo-item accuracy/altitude is stored in meters but displayed in feet
 * (mirrors the mobile `unitConversion` helper).
 */
export function metersToFeet(meters: number): number {
  return meters * METERS_TO_FEET;
}

/**
 * Formats a meters value as a fixed-decimal feet string (no unit suffix).
 * Callers append ` ft`. Used for HRMS/VRMS/altitude across exports and the web form.
 */
export function formatAccuracyFeet(meters: number, decimals = 3): string {
  return metersToFeet(meters).toFixed(decimals);
}
